import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatus = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [systemStats, setSystemStats] = useState({
    uptime: '99.9%',
    responseTime: '< 24h',
    messagesProcessed: 1247,
    satisfaction: '98.5%'
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const statusItems = [
    {
      label: 'System Status',
      value: 'Online',
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Response Time',
      value: systemStats?.responseTime,
      icon: 'Clock',
      color: 'text-terminal-blue',
      bgColor: 'bg-terminal-blue/10'
    },
    {
      label: 'Messages Processed',
      value: systemStats?.messagesProcessed?.toLocaleString(),
      icon: 'Mail',
      color: 'text-terminal-cyan',
      bgColor: 'bg-terminal-cyan/10'
    }
  ];

  const timeZones = [
    { zone: 'UTC', time: currentTime?.toLocaleTimeString('en-US', { timeZone: 'UTC', hour12: false }) },
    { zone: 'IST', time: currentTime?.toLocaleTimeString('en-US', { timeZone: 'Asia/Kolkata', hour12: false }) },
    { zone: 'PST', time: currentTime?.toLocaleTimeString('en-US', { timeZone: 'America/Los_Angeles', hour12: false }) },
  ];

  return (
    <div className="space-y-10">
      {/* Contact Methods */}
      <div className="bg-card border border-terminal-muted rounded-lg p-4 terminal-glow">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="MessageSquare" size={20} className="text-primary" />
          <h3 className="font-medium text-foreground font-inter">Available Contact Methods</h3>
        </div>
        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 bg-muted/20 rounded-md">
            <div className="flex items-center space-x-3">
              <Icon name="Mail" size={16} className="text-terminal-blue" />
              <span className="text-sm font-source">Email Response</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
              <span className="text-xs text-success font-fira">Active</span>
            </div>
          </div>
          <div className="flex items-center justify-between p-3 bg-muted/20 rounded-md">
            <div className="flex items-center space-x-3">
              <Icon name="Phone" size={16} className="text-terminal-cyan" />
              <span className="text-sm font-source">Video Call</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-warning rounded-full animate-pulse"></div>
              <span className="text-xs text-warning font-fira">By Appointment</span>
            </div>
          </div>
          <div className="flex items-center justify-between p-3 bg-muted/20 rounded-md">
            <div className="flex items-center space-x-3">
              <Icon name="Calendar" size={16} className="text-primary" />
              <span className="text-sm font-source">Meeting Scheduler</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
              <span className="text-xs text-success font-fira">Available</span>
            </div>
          </div>
        </div>
      </div>

      {/* System Status Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {statusItems?.map((item, index) => (
          <div
            key={index}
            className={`${item?.bgColor} border border-terminal-muted rounded-lg p-4 terminal-glow`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-muted-foreground font-source uppercase tracking-wide">
                  {item?.label}
                </p>
                <p className={`text-lg font-bold ${item?.color} font-fira mt-1`}>
                  {item?.value}
                </p>
              </div>
              <Icon name={item?.icon} size={24} className={item?.color} />
            </div>
          </div>
        ))}
      </div>

      {/* Time Zones */}
      <div className="bg-card border border-terminal-muted rounded-lg p-4 terminal-glow">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Globe" size={20} className="text-primary" />
          <h3 className="font-medium text-foreground font-inter">Global Time Zones</h3>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {timeZones?.map((tz, index) => (
            <div key={index} className="text-center">
              <div className="text-xs text-muted-foreground font-source uppercase tracking-wide">
                {tz?.zone}
              </div>
              <div className="text-lg font-bold text-primary font-fira mt-1">
                {tz?.time}
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* System Information */}
      {/* <div className="bg-card border border-terminal-muted rounded-lg p-4 terminal-glow">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Info" size={20} className="text-primary" />
          <h3 className="font-medium text-foreground font-inter">System Information</h3>
        </div>
        <div className="space-y-2 text-sm font-source">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Last Updated:</span>
            <span className="text-foreground">{currentTime?.toLocaleDateString()}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Version:</span>
            <span className="text-foreground">v2.1.0</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Environment:</span>
            <span className="text-success">Production</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Satisfaction Rate:</span>
            <span className="text-primary">{systemStats?.satisfaction}</span>
          </div>
        </div>
      </div> */}



    </div>
  );
};

export default SystemStatus;